import { render, staticRenderFns } from "./Emailtemplate.vue?vue&type=template&id=e6cdcf86&scoped=true&"
import script from "./Emailtemplate.vue?vue&type=script&lang=js&"
export * from "./Emailtemplate.vue?vue&type=script&lang=js&"
import style0 from "./Emailtemplate.vue?vue&type=style&index=0&id=e6cdcf86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cdcf86",
  null
  
)

export default component.exports